const Menu: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M10 3V7H14V3H10ZM10 10V14H14V10H10ZM10 17V21H14V17H10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Menu;
